import React, { useEffect, useState } from "react";
import {
  Box,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  TableContainer,
  Paper,
  Typography,
  TablePagination,
  CircularProgress,
} from "@mui/material";
import axios from "axios";

const TrackingOfferList = ({ id }) => {
  const [data, setData] = useState({
    list: [],
    totalCount: 0,
    totalPages: 0,
    currentPage: 1,
  });
  const [loading, setLoading] = useState(false);

  const [page, setPage] = useState(0); // 0-based for MUI
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const baseUrl = "https://api.medstown.com";

  const fetchTrackingData = async () => {
    setLoading(true);
    try {
      const response = await axios.get(
        `${baseUrl}/offer/coupons/tracking/${id}?page=${
          page + 1
        }&limit=${rowsPerPage}`
      );
      console.log("Tracking Offer List Response:", response.data);
      setData(response?.data?.data);
    } catch (error) {
      console.error("Error fetching tracking offer list:", error);
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchTrackingData();
  }, [id, page, rowsPerPage]);

  const handleChangePage = (event, newPage) => setPage(newPage);

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  return (
    <Box sx={{ mt: 3 }}>
      <Typography variant="h6" gutterBottom>
        Tracking Offer List
      </Typography>

      {loading ? (
        <Box display="flex" justifyContent="center" mt={4}>
          <CircularProgress />
        </Box>
      ) : (
        <TableContainer
          component={Paper}
          elevation={3}
          sx={{ borderRadius: 2 }}
        >
          <Table>
            <TableHead sx={{ backgroundColor: "#f5f5f5" }}>
              <TableRow>
                <TableCell>
                  <b>User</b>
                </TableCell>
                <TableCell>
                  <b>Phone</b>
                </TableCell>
                <TableCell>
                  <b>Order ID</b>
                </TableCell>
                <TableCell>
                  <b>Amount Before</b>
                </TableCell>
                <TableCell>
                  <b>Amount After</b>
                </TableCell>
                <TableCell>
                  <b>Saved</b>
                </TableCell>
                <TableCell>
                  <b>Applied On</b>
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {data?.list.map((row) => (
                <TableRow key={row._id}>
                  <TableCell>{row.user_id?.fullName || "-"}</TableCell>
                  <TableCell>{row.user_id?.phone || "-"}</TableCell>
                  <TableCell>{row.order_id}</TableCell>
                  <TableCell>₹{row.amount_before}</TableCell>
                  <TableCell>₹{row.amount_after}</TableCell>
                  <TableCell>₹{row.saved_amount}</TableCell>
                  <TableCell>
                    {new Date(row.applied_on).toLocaleString()}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
          <TablePagination
            component="div"
            count={data.totalCount}
            page={page}
            onPageChange={handleChangePage}
            rowsPerPage={rowsPerPage}
            onRowsPerPageChange={handleChangeRowsPerPage}
            rowsPerPageOptions={[5, 10, 25]}
          />
        </TableContainer>
      )}
    </Box>
  );
};

export default TrackingOfferList;
